import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Llevaba 2 años despertándome a las 3am casi todas las noches. En la Noche 4 del método por primera vez dormí de corrido. Lloré de alivio.',
  name: 'Mariana G.',
  age: '38 años',
  location: 'Ciudad de México'
}, {
  quote: "Siempre pensé que era 'mala durmiendo'. Lo que no sabía es que simplemente nadie me había enseñado a cerrar el día. El ritual de la Noche 1 cambió todo para mí.",
  name: 'Sofía R.',
  age: '34 años',
  location: 'Buenos Aires'
}, {
  quote: 'Lo que más me sorprendió es que no requiere mucho tiempo. 10 minutos antes de dormir y en 5 días ya me sentía diferente. Mi pareja me preguntó qué había cambiado.',
  name: 'Carolina V.',
  age: '44 años',
  location: 'Madrid'
}];
export function Testimonials() {
  return <section className="w-full bg-[#FDFBFF] py-16 md:py-24 px-6" data-id="element-367">
      <div className="max-w-6xl mx-auto" data-id="element-368">
        <FadeIn data-id="element-369">
          <h2 className="text-3xl md:text-4xl font-serif text-night-900 text-center mb-12 md:mb-16" data-id="element-370">
            Lo que dicen quienes ya lo usaron:
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-371">
          {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-372">
              <div className="bg-white p-6 md:p-8 rounded-3xl shadow-sm border border-purple-100 border-t-4 border-t-purple-400 h-full flex flex-col" data-id="element-373">
                <div className="flex space-x-1 mb-4 md:mb-6" data-id="element-374">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-yellow-400 text-yellow-400" data-id="element-375" />)}
                </div>
                <p className="text-base md:text-lg text-slate-700 italic mb-6 md:mb-8 flex-grow" data-id="element-376">
                  "{t.quote}"
                </p>
                <div data-id="element-377">
                  <p className="font-bold text-night-900" data-id="element-378">{t.name}</p>
                  <p className="text-xs md:text-sm text-slate-500" data-id="element-379">
                    {t.age} — {t.location}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}